









import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';

import { Validator } from 'vee-validate';

import Customer from '@/classes/Customer';

import InternForm from './InternForm.vue';

const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    InternForm,
  },
})
export default class EssencialInfo extends Vue {
  @Prop({
    default: () => ({
      name: '',
      document: '',
      birthday: '',
      email: '',
      phone: '',
    }),
  })
  private readonly customer!: Customer;

  private customerLocal: Customer = new Customer();

  private validator = new Validator();

  private validated: boolean = false;

  @CustomerModule.Action
  private updateCustomer!: (payload: any)=> any;

  @CustomerModule.Action
  private userPhoneCreate!: (payload: any)=> any;

  validateCustomer() {
    return new Promise(async (resolve: any, reject) => {
      const result = await this.validator.validateAll({
        ...this.customerLocal,
      });

      this.validated = true;

      result && await this.updateCustomerData();

      result
        ? resolve()
        : reject();
    });
  }

  private async updateCustomerData() {
    try {
      await this.updateCustomer(this.customerLocal);

      if (this.diffPhoneValue()) {
        const { phone }: any = this.customerLocal;

        await this.userPhoneCreate({
          userId: this.customer.acta_user_id,
          phone: {
            is_active: true,
            is_default: true,
            phone: `+55${phone.replace(/\D/g, '')}`
          }
        });
      }
      this.$emit('errorUpdateCustomer', false);
    } catch (error) {
      error && this.$emit('errorUpdateCustomer', true);
    }
  }

  private diffPhoneValue() {
    let diff = false;
    const phone: any = this.customerLocal;

    if (this.customer && this.customer.phone_numbers && this.customer.phone_numbers.length > 0) {
      const phoneActivated = this.filterPhoneIsActive(this.customer.phone_numbers);

      return phoneActivated && phoneActivated.phone.replace('+55', '') !== phone.phone.replace(/\D/g, '');
    }

    return false;
  }

  private filterPhoneIsActive(phones: any) {
    return phones.find((phone: any) => phone.is_active && phone.is_default);
  }

  @Watch('customerLocal', { deep: true })
  onChangeDeliveryAddress (value: any) {
    if (this.validated) {
      this.validator.reset();
    }
  }

  mounted () {
    this.customerLocal = Object.assign({}, this.customer);
  }
}
